/**
 * GlobalBanner - Shows system-wide banner messages
 * 
 * Displays when banner_enabled=true in app_control
 * Supports 'info' and 'warning' severity levels
 */
import { useAppControl } from '@/hooks/useAppControl';
import { AlertTriangle, Info, X } from 'lucide-react';
import { useState } from 'react';
import { cn } from '@/lib/utils';

export function GlobalBanner() {
  const { data: appControl, isLoading } = useAppControl();
  const [dismissed, setDismissed] = useState(false);

  // Don't show anything while loading or if no data
  if (isLoading || !appControl) return null;

  // Don't show if banner is disabled or dismissed
  if (!appControl.banner_enabled || dismissed) return null;

  // Don't show if message is empty
  if (!appControl.banner_message?.trim()) return null;

  const isWarning = appControl.banner_severity === 'warning';

  return (
    <div
      className={cn(
        'fixed top-0 left-0 right-0 z-[100] px-4 py-2 flex items-center justify-center gap-2 text-sm font-medium shadow-md',
        isWarning
          ? 'bg-amber-500 text-amber-950'
          : 'bg-blue-500 text-white'
      )}
    >
      {isWarning ? (
        <AlertTriangle className="h-4 w-4 flex-shrink-0" />
      ) : (
        <Info className="h-4 w-4 flex-shrink-0" />
      )}
      <span className="text-center">{appControl.banner_message}</span>
      <button
        onClick={() => setDismissed(true)}
        className="ml-4 p-1 rounded hover:bg-black/10 transition-colors"
        aria-label="Sulje ilmoitus"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
